module.exports = __webpack_public_path__ + "img/product-brakedisk-slider.b57ec440.jpg";